<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M22.58 12.0261C22.8051 12.2936 22.8065 12.6839 22.5832 12.953L20.5996 15.3442C20.3447 15.6515 19.8889 15.6939 19.5817 15.439C19.2744 15.1841 19.2319 14.7284 19.4868 14.4211L20.488 13.2143L12.0917 13.2143C11.6924 13.2143 11.3688 12.8907 11.3688 12.4915C11.3688 12.0922 11.6924 11.7686 12.0917 11.7686L20.4741 11.7686L19.49 10.5989C19.233 10.2934 19.2723 9.83739 19.5778 9.58037C19.8833 9.32336 20.3393 9.36267 20.5964 9.66817L22.58 12.0261Z" fill="#575757" stroke="#575757" stroke-width="0.4" stroke-linecap="round" stroke-linejoin="round"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.343 4.3652C18.343 3.96597 18.0194 3.64233 17.6201 3.64233H5.69542C5.29619 3.64233 4.97255 3.96597 4.97255 4.3652V20.651C4.97255 21.0502 5.29619 21.3738 5.69542 21.3738H17.6201C18.0194 21.3738 18.343 21.0502 18.343 20.651V16.0492C18.343 15.6499 18.0194 15.3263 17.6201 15.3263C17.2209 15.3263 16.8973 15.6499 16.8973 16.0492V19.9281H6.41829V5.08808H16.8973V8.81765C16.8973 9.21688 17.2209 9.54052 17.6201 9.54052C18.0194 9.54052 18.343 9.21688 18.343 8.81765V4.3652Z" fill="#575757" stroke="#575757" stroke-width="0.4" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'logoutIcon'
}
</script>

<style scoped>

</style>
